<div class="flex flex-column justify-content-center m-2">
    <h4>הצמד כרטיס לקורא לגב המכשיר</h4>
    <button pButton pRipple type="button" label="{{'GENERAL.CANCEL'|translate}}" (click)="closeDialog()"></button>
</div>